module.exports = __webpack_public_path__ + "media/images/social/yt-dark-4d13b04874a62659dc8be4549a735238.svg";